var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
import { COLORS, BORDER_RADIUS } from '../../constants';
import { labelMargin } from './constants';
var addonStyles = {
  display: 'inline-block',
  height: '40px',
  padding: '0 10px',
  lineHeight: '38px',
  background: COLORS.grays["super"],
  border: "solid 1px " + COLORS.grays.lighter,
  color: COLORS.grays.gray,
  whiteSpace: 'nowrap'
};
var prefixStyles = {
  borderTopLeftRadius: BORDER_RADIUS.medium,
  borderBottomLeftRadius: BORDER_RADIUS.medium,
  borderRight: 'none'
};
var suffixStyles = {
  borderLeft: 'none',
  borderTopRightRadius: BORDER_RADIUS.medium,
  borderBottomRightRadius: BORDER_RADIUS.medium
};
var smallStyles = {
  height: 32,
  fontSize: 14,
  lineHeight: '30px'
};
var largeStyles = {
  height: 48,
  fontSize: 18,
  lineHeight: '46px'
};
var labelAdjustments = {
  margin: labelMargin
};

var Addon = function Addon(_a) {
  var children = _a.children,
      size = _a.size,
      type = _a.type,
      hasLabel = _a.hasLabel;
  var styles = [addonStyles];
  if (type === 'prefix') styles.push(prefixStyles);
  if (type === 'suffix') styles.push(suffixStyles);
  if (size === 'small') styles.push(smallStyles);
  if (size === 'large') styles.push(largeStyles);
  if (hasLabel) styles.push(labelAdjustments);
  return jsx("div", {
    css: styles
  }, children);
};

export var Prefix = function Prefix(props) {
  return jsx(Addon, __assign({}, props, {
    type: "prefix"
  }));
};
export var Suffix = function Suffix(props) {
  return jsx(Addon, __assign({}, props, {
    type: "suffix"
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Input/addon.js
// module id = 957
// module chunks = 0